// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2RaXz","title":"Info_title__2VWSs","selects":"Info_selects__3vMqg","requiredAsterisk":"Info_requiredAsterisk__21OC_"};